import { Box } from '@mui/material'
import React from 'react'
import AddFavorite from '../button/AddFavorite';
import Image from 'next/image';
import { Report } from '@/models/report';
import styles from "./styles.module.scss";
import { TYPE_PAGE } from '@/utils/AppConfig';

interface ImageProps {
    report?: Report;
    isLoggedIn?: boolean;
    slug?: string;
    lang?: string;
    type: number;
    token?: string;
}



const ContentImage = ({ report, isLoggedIn, slug, lang, type, token }: ImageProps) => {

    const handleQueryKey = (type: number) => {
        switch (type) {
            case TYPE_PAGE.DETAIL_SHARE:
                return ["report", slug];
            case TYPE_PAGE.INTERACTIVE_SHARE:
                return ["interactive-report", token];
            default:
                return ["report", slug, lang];
        }
    }


    return (
        <Box
            className={`${isLoggedIn && "relative"} h-auto lg:flex lg:justify-center xl:block xl:h-auto`}
        >
            <Box className=" bg-[#F8FCE8] relative py-8 px-1 h-[248px] sm:h-full lg:h-[256px] xl:w-full lg:w-full">
                <Box className="bg-[#F2F7FD] absolute bottom-0 left-0 w-full h-[89px]"></Box>
                <Box className="relative flex justify-center items-center">
                    {report?.image && (
                        <Box className="w-auto sm:w-[520px] lg:w-[340px] xl:w-[320px] sm:h-[300px] md:h-[300px] lg:h-[200px] xl:h-[185px]">
                            <Image
                                src={report?.image}
                                alt={`${report?.image}`}
                                priority={true}
                                width={320}
                                height={186}
                                quality={90}
                                className={`${styles.img_mobile} w-auto sm:w-[520px] lg:w-[340px] xl:w-[320px] sm:h-[300px] md:h-[300px] lg:h-[200px] xl:h-[185px] shadow-[0px_4px_6px_0px_rgba(0, 0, 0, 0.15)]`}
                            />
                        </Box>
                    )}
                </Box>
                {isLoggedIn && type !== TYPE_PAGE.DETAIL_SHARE && (
                    <AddFavorite
                        dataDetail={report}
                        queryKey={handleQueryKey(type)}
                    />
                )}
            </Box>
        </Box>
    )
}

export default ContentImage